import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";

const useStyles = createUseStyles({
  divPrivacy: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "15px",
    padding: "15px",
    gap: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  description: {
    color: colors.greydark,
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    flexWrap: "wrap",
    borderTop: `1px solid ${colors.borderLight}`,
    paddingTop: "12px",
    "@media (max-width:599.95px)": {
      flexDirection: "column",
    },
  },
  confirmText: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "10px 0px",
    minWidth: "min(380px, 78vw)",
  },
});

export default useStyles;
